const TEXTAREA_SELECTOR = 'textarea.form__input--text';

const toPx = (value) => Number.parseFloat(value) || 0;

const getTextHeight = (textarea, styles) => {
  const mirror = document.createElement('div');
  const textWidth =
    textarea.clientWidth - toPx(styles.paddingLeft) - toPx(styles.paddingRight);

  mirror.style.position = 'absolute';
  mirror.style.visibility = 'hidden';
  mirror.style.pointerEvents = 'none';
  mirror.style.zIndex = '-1';
  mirror.style.whiteSpace = 'pre-wrap';
  mirror.style.overflowWrap = 'break-word';
  mirror.style.boxSizing = 'border-box';
  mirror.style.font = styles.font;
  mirror.style.lineHeight = styles.lineHeight;
  mirror.style.letterSpacing = styles.letterSpacing;
  mirror.style.textTransform = styles.textTransform;
  mirror.style.width = `${Math.max(0, textWidth)}px`;
  mirror.textContent = textarea.value || ' ';

  document.body.appendChild(mirror);
  const height = mirror.scrollHeight;
  mirror.remove();

  return height;
};

const prepareTextarea = (textarea) => {
  textarea.style.height = '';
  textarea.style.paddingTop = '';

  const styles = window.getComputedStyle(textarea);
  const height = textarea.getBoundingClientRect().height;

  if (!height) {
    return false;
  }

  textarea.dataset.bottomFillBasePaddingTop = styles.paddingTop;
  textarea.dataset.bottomFillBaseHeight = `${height}`;
  textarea.style.boxSizing = 'border-box';
  textarea.style.height = `${height}px`;

  return true;
};

const updateTextarea = (textarea) => {
  if (!textarea.dataset.bottomFillBaseHeight && !prepareTextarea(textarea)) {
    return;
  }

  const styles = window.getComputedStyle(textarea);
  const baseHeight = toPx(textarea.dataset.bottomFillBaseHeight);
  const basePaddingTop = toPx(textarea.dataset.bottomFillBasePaddingTop);
  const paddingBottom = toPx(styles.paddingBottom);
  const borderTop = toPx(styles.borderTopWidth);
  const borderBottom = toPx(styles.borderBottomWidth);

  textarea.style.height = `${baseHeight}px`;
  textarea.style.paddingTop = `${basePaddingTop}px`;

  const textHeight = getTextHeight(textarea, styles);
  const availableTextArea =
    baseHeight - borderTop - borderBottom - basePaddingTop - paddingBottom;
  const extraTopPadding = Math.max(0, availableTextArea - textHeight);

  textarea.style.paddingTop = `${basePaddingTop + extraTopPadding}px`;
  textarea.style.overflowY = textHeight > availableTextArea ? 'auto' : 'hidden';
  textarea.scrollTop = textarea.scrollHeight;
};

const resetTextarea = (textarea) => {
  delete textarea.dataset.bottomFillBaseHeight;
  delete textarea.dataset.bottomFillBasePaddingTop;
  prepareTextarea(textarea);
  updateTextarea(textarea);
};

const bindTextarea = (textarea) => {
  if (textarea.dataset.bottomFillReady === 'true') {
    return;
  }

  textarea.dataset.bottomFillReady = 'true';
  resetTextarea(textarea);

  textarea.addEventListener('input', () => updateTextarea(textarea));
  textarea.addEventListener('change', () => updateTextarea(textarea));
};

export const initBottomFillTextareas = () => {
  const textareas = Array.from(document.querySelectorAll(TEXTAREA_SELECTOR));

  if (!textareas.length) {
    return;
  }

  textareas.forEach(bindTextarea);

  window.addEventListener('resize', () => {
    textareas.forEach(resetTextarea);
  });

  if (document.fonts?.ready) {
    document.fonts.ready.then(() => {
      textareas.forEach(resetTextarea);
    });
  }
};
